import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, AuthService, MessageService } from '../../../core';
import { UsuarioFilter } from '../filter';
import { usuarioAtivo } from '../usuario-situacao';
import { UsuarioCrudHttpService } from '../services';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-usuario-multiselect',
    templateUrl: './usuario-multiselect.component.html',
    styleUrls: ['./usuario-multiselect.component.less']
})
export class UsuarioMultiselectComponent implements OnInit {
    /** ID do usuário logado */
    private idUsuarioLogado: number;

    /** Usuários selecionados */
    @Input() idsUsuarios: number[];
    /** Ao alterar a seleção dos usuários */
    @Output() idsUsuariosChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;
    /** Se deve exibir a flag de "EU" no usuário atualmente logado */
    @Input() isShowLabelEu = true;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Usuário';
    @Input() checked = 'Usuário';
    @Input() checkedPlural = 'Usuários';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum usuário encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private authService: AuthService,
                private messageService: MessageService,
                private usuarioCrudHttpService: UsuarioCrudHttpService) { }

    ngOnInit() {
        this.idUsuarioLogado = this.authService.getIdUsuario();

        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-usuario ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os tipos de bonificações para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        const filter = new UsuarioFilter();
        // Somente Ativos
        filter.situacao = usuarioAtivo.id;

        this.usuarioCrudHttpService.searchWithFilter(filter, null, null, null, null, null)
            .pipe(
                take(1)
            )
            .subscribe(
                response => {
                    if (response && response.data) {
                        response.data.forEach(entity => {
                            let nome = entity.nome;
                            if (this.isShowLabelEu && entity.id === this.idUsuarioLogado) {
                                nome += ' (EU)';
                            }

                            selects.push({
                                id: entity.id,
                                name: nome
                            });
                        });
                        this.options = selects;
                    }
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao pesquisar os usuários', error);
                }
            );
    }

    /** Ao alterar a seleção dos usuários */
    onChange() {
        this.idsUsuariosChange.emit(this.idsUsuarios);
    }
}
